import styled from 'styled-components';
import { Label } from '../../../components/uielements';
import { key, palette } from 'styled-theme';

const tabletBreakpoint = key('breakpoints.tablet', '820px');
const mobileBreakpoint = key('breakpoints.mobile', '480px');

const gap = {
  medium: key('sizes.gap.normal', '16px'),
  big: key('sizes.gap.medium', '24px'),
};

export const Main = styled.main`
  display: grid;
  grid-template-columns: 1fr 1fr;
  height: 100vh;
  width: 100vw;
  @media (max-width: ${mobileBreakpoint}) {
    grid-template-columns: 1fr;
    height: 100dvh;
    width: 100%;
  }
`;

export const SectionLeft = styled.section`
  background-color: ${palette('background', 0)};
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 30px;
  padding: 120px;

  @media (max-width: ${tabletBreakpoint}) {
    width: 100%;
    gap: ${gap.medium};
    padding: 0 ${gap.medium};
  }

  @media (max-width: ${mobileBreakpoint}) {
    grid-template-columns: 1fr;
    width: 100%;
    gap: ${gap.medium};
    padding: 0 ${gap.medium};
  }
`;

export const SectionRight = styled.section`
  background-image: url(${(props) => props.bg});
  transition: background-image 0.5s ease-in-out;
  background-size: cover;
  background-position: center;
  @media (max-width: ${mobileBreakpoint}) {
    display: none;
  }
`;

export const Heading = styled(Label).attrs({ size: 'header2', color: 'black', weight: 'bold' })`
  text-transform: uppercase;
`;

export const SubHeading = styled(Label).attrs({ color: 'black' })`
  font-family: 'Inter';
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
`;
